import { render } from "./OptionNotification.vue?vue&type=template&id=02e5d186&scoped=true"
import script from "./OptionNotification.vue?vue&type=script&lang=js"
export * from "./OptionNotification.vue?vue&type=script&lang=js"

import "./OptionNotification.vue?vue&type=style&index=0&id=02e5d186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e5d186"]])

export default __exports__